import { pillars } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import './Pillars.css';

export function Pillars() {
  return (
    <Section id="ia" label="Tres niveles de IA" title="Del equipo al agente autónomo" lead="Como las mejores plataformas de comunicación: tú controlas el espectro entre humano e inteligencia artificial.">
      <div className="pillars-grid">
        {pillars.map((p, i) => (
          <ScrollReveal key={p.id} delay={i * 100}>
            <article className={`glass-card pillar-card pillar-card--${p.id}`}>
              <span className="pillar-card__tag">{p.tag}</span>
              <h3>{p.title}</h3>
              <p className="pillar-card__body">{p.body}</p>
              <ul className="pillar-card__list">
                {p.highlights.map((h) => (
                  <li key={h}>{h}</li>
                ))}
              </ul>
            </article>
          </ScrollReveal>
        ))}
      </div>
    </Section>
  );
}
